// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronLeftSmallIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronLeftSmallIcon" ref={forwardedRef} {...props}>
      <path d="M11.243 5.755 7 9.998l4.243 4.243 1.06-1.061-3.182-3.182 3.182-3.182z" />
    </SvgIcon>
  );
});

/**
 * Indicates the ability to navigate to a previous step or view overflow items to the left. Do not use in trees to show something is closed
 * @public
 */
export const ChevronLeftSmallIcon = /* @__PURE__ */ Object.assign(
  ChevronLeftSmallIconComponent,
  { displayName: 'ChevronLeftSmallIcon' },
);
